<template>
  <div class="content">
    <div class="content-bottom">
      <div class="bottom-one">
        <div class="bottom">
          <img src="../assets/slices/dianhua-yuankuang.png" alt="" />
          <span>400-0377-001</span>
        </div>
        <div class="bottom">
          <img src="../assets/slices/dizhi01.png" alt="" />
          <span>河南省金水区郑州市环球大厦C座1703</span>
        </div>
      </div>

      <div class="bottom-two">
        <div class="bottom">
          <img src="../assets/slices/youxiang-2.png" alt="" />
          <span>losofu@qq.com</span>
        </div>
        <div class="bottom">
          <img src="../assets/slices/bianhao.png" alt="" />
          <a href="https://beian.miit.gov.cn/#/Integrated/index"
            >豫ICP备2024042061号</a
          >
        </div>
      </div>

      <div class="content-sys">
        <img src="../assets/slices/slices/ewm.png" alt="" />
        <p>扫一扫 联系我们！</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 19rem;
  background: #08264d;
  color: #fff;
  .content-bottom {
    width: 108rem;
    height: 100%;
    // background: #22293d;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .bottom-one {
      .bottom {
        display: flex;
        align-items: center;
        margin-left: 1rem;
        margin-top: 1rem;
        img {
          width: 3.5rem;
          height: 3.5rem;
        }
        span {
          font-size: 1.8rem;
          color: #ffffff;
          line-height: 2.1rem;
          text-align: left;
          font-style: normal;
          margin-left: 0.5rem;
        }
      }
    }
    .bottom-two {
      .bottom {
        display: flex;
        align-items: center;
        margin-left: 1rem;
        margin-top: 1rem;
        img {
          width: 3.5rem;
          height: 3.5rem;
        }
        span {
          font-size: 1.8rem;
          color: #ffffff;
          line-height: 2.1rem;
          text-align: left;
          font-style: normal;
          margin-left: 0.5rem;
        }
        a {
          font-size: 1.8rem;
          color: #fff;
          text-decoration: none;
          margin-left: 0.5rem;
        }
      }
    }

    .content-sys {
      margin-left: 9rem;
      img {
        width: 10rem;
        height: 10rem;
      }
    }
  }
}
</style>
